

import React, { useEffect, useState } from 'react';
import './ProductCatalog.css';
import './ProductCatalog.detail.css';
import api from '../utils/api';


const ProductCatalog = ({ onAddToCart }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get('/products')
      .then(res => setProducts(res.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Уншиж байна...</div>;

  // Find similar ads (same category, exclude self)
  const getSimilar = (product) => {
    if (!product) return [];
    return products.filter(p => p.category === product.category && p._id !== product._id).slice(0, 4);
  };

  return (
    <div className="product-catalog">
      <h2>Зарын зах зээл</h2>
      <div className="product-list">
        {products.map(product => (
          <div className="product-card" key={product._id} onClick={() => setSelected(product)} style={{cursor:'pointer'}}>
            {product.image && <img src={product.image} alt={product.name} className="product-img" />}
            <h3>{product.name}</h3>
            <p>{product.description}</p>
            <div className="product-price">{product.price}₮</div>
            <button onClick={e => { e.stopPropagation(); onAddToCart && onAddToCart(product._id); }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M10 8V12M8 10H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <span style={{marginLeft:4}}>Сагсанд нэмэх</span>
            </button>
          </div>
        ))}
      </div>

      {/* Detail modal */}
      {selected && (
        <div className="product-detail-backdrop" onClick={() => setSelected(null)}>
          <div className="product-detail-modal" onClick={e => e.stopPropagation()}>
            <button className="product-detail-close" onClick={() => setSelected(null)}>✕</button>
            <div className="product-detail-main">
              {selected.image && <img src={selected.image} alt={selected.name} className="product-detail-img" />}
              <div className="product-detail-info">
                <h2>{selected.name}</h2>
                <div className="product-detail-price">{selected.price}₮</div>
                <div className="product-detail-meta">
                  <span>Ангилал: {selected.category || '—'}</span>
                  <span>Зарын ID: {selected._id}</span>
                </div>
                <p className="product-detail-desc">{selected.description}</p>
                <button className="product-detail-cart-btn" onClick={() => { onAddToCart && onAddToCart(selected._id); setSelected(null); }}>Сагсанд нэмэх</button>
              </div>
            </div>
            <div className="product-detail-similar">
              <h4>Төстэй зарууд</h4>
              <div className="product-list" style={{marginTop:8}}>
                {getSimilar(selected).map(sim => (
                  <div className="product-card" key={sim._id} onClick={() => setSelected(sim)}>
                    {sim.image && <img src={sim.image} alt={sim.name} className="product-img" />}
                    <h3>{sim.name}</h3>
                    <div className="product-price">{sim.price}₮</div>
                  </div>
                ))}
                {getSimilar(selected).length === 0 && <div style={{color:'#888'}}>Төстэй зар алга</div>}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCatalog;
